import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "components/modal/Modal";
import SecondaryButton from "ui/buttons/SecondaryButton";
import LoadingPrimaryButton from "ui/buttons/LoadingPrimaryButton";
import PrimaryButton from "ui/buttons/PrimaryButton";
import { CheckIcon } from "@heroicons/react/outline";
import { Popover } from "@headlessui/react";
import customAxios from "middleware/customAxios";

export default function AssignCustomer({ setOpen }) {
  let navigate = useNavigate();

  const [showModal, setShowModal] = useState(true);
  const [customerQuery, setCustomerQuery] = React.useState("");
  const [selectedCustomer, setSelectedCustomer] = React.useState(null);
  const [customers, setCustomers] = React.useState([]);
  let id = useParams().id;
  let [selectedSerializedProduct, setSelectedSerializedProduct] =
    React.useState({});

  let modalChange = () => {
    console.log("hit");
    setShowModal(false);
    navigate("/products/serialized-products");
  };

  React.useEffect(() => {
    customAxios.get("/admin/serialized-product/" + id).then((res) => {
      setSelectedSerializedProduct(res);
    });
  }, [id]);

  React.useEffect(() => {
    let urlParams = new URLSearchParams();
    urlParams.append("accountNumber", customerQuery);

    if (customerQuery.length > 3) {
      customAxios.get("/admin/customers?" + urlParams).then((res) => {
        setCustomers(res);
      });
    }
  }, [customerQuery]);

  React.useEffect(() => {
    setShowModal(true);
  }, []);

  return (
    <div className="  ">
      <Modal
        show={showModal}
        setShowModal={modalChange}
        heading="Assign Customer to STB"
        subHeading="Please fill the form below to assign customer to STB"
      >
        <div className="p-5">
          {/* Assign customer */}
          <div>
            <div className="grid grid-cols-1 font-bold gap-3">Customer</div>
            <Popover className={"relative focus:outline-none "}>
              {({ open, close }) => (
                <>
                  <Popover.Button
                    className={`w-full ${
                      open ? "" : "text-opacity-70"
                    } flex flex-row py-2`}
                  >
                    <div className="flex flex-row space-x-3 items-center w-full">
                      <div className="flex flex-col border border-slate-300 w-full p-2 rounded-md space-y-1">
                        <h1 className="text-sm text-start ">
                          {selectedCustomer?.name ?? (
                            <p className="text-yellow-600">
                              Please Select a Customer
                            </p>
                          )}
                        </h1>
                      </div>
                    </div>
                  </Popover.Button>
                  <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 top-1 -left-4">
                    <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                      <div className="relative grid gap-2 bg-white  p-2 ">
                        <div className="flex flex-row space-x-3 items-center">
                          <div className="flex flex-col space-y-2 w-full">
                            <input
                              type="number"
                              className="w-full border border-slate-300 rounded-md p-2"
                              placeholder="Search Customer"
                              value={customerQuery}
                              onChange={(e) => {
                                if (e.target.value.length > 6) return;
                                setCustomerQuery(e.target.value);
                              }}
                              maxLength={6}
                            />
                            <div className="flex flex-col text-sm space-y-2">
                              <p>Results</p>
                              {customers.length === 0 ? (
                                <p className="text-yellow-600">
                                  No Customer Found
                                </p>
                              ) : (
                                <>
                                  {customers?.map((customer) => {
                                    return (
                                      <button
                                        onClick={() => {
                                          setSelectedCustomer(customer);
                                          close();
                                        }}
                                        className={`flex flex-row  hover:bg-white items-center space-x-4 p-2 rounded-xl ${
                                          selectedCustomer?.id == customer?.id
                                            ? "bg-white border-2 border-slate-400"
                                            : ""
                                        }`}
                                      >
                                        {selectedCustomer?.id ===
                                        customer?.id ? (
                                          <CheckIcon className="h-6 w-6 text-yellow-500" />
                                        ) : (
                                          <div className="h-6 w-6"></div>
                                        )}

                                        <p className="text-sm font-medium text-slate-900">
                                          {customer?.name} -{" "}
                                          {customer?.accountNumber}
                                        </p>
                                      </button>
                                    );
                                  })}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Popover.Panel>
                </>
              )}
            </Popover>
          </div>
        </div>

        <div class="bg-gray-50 sticky bottom-0 w-full px-4 py-3 md:flex grid grid-cols-2 gap-3  justify-end items-center flex-row space-x-3">
          <SecondaryButton onClick={modalChange} title={"Cancel"} />

          <PrimaryButton
            onClick={() => {
              customAxios
                .put("/admin/serialized-products/" + id + "/assign-customer", {
                  accountNumber: selectedCustomer?.accountNumber,
                })
                .then(
                  (res) => {
                    modalChange();
                    console.log(res);
                  },
                  (err) => {
                    console.log(err);
                    alert(err.response.data.message);
                  }
                );
            }}
            title={"Assign"}
          />
        </div>
      </Modal>
    </div>
  );
}
